module.exports = __webpack_public_path__ + "img/girl.b104fe1f.png";